/* istanbul ignore file */
import gql from 'graphql-tag';

export default gql`
  mutation addCustomerBoardAsset(
    $customerBoardId: ID!,
    $sourceBoardId: ID!,
    $assetId: ID!
  ) {
    addCustomerBoardAsset(
      customerBoardId: $customerBoardId,
      sourceBoardId: $sourceBoardId,
      assetId: $assetId
    ) {
      customerPrimaryImage
      exploreBoardItems(limit: 9) {
        imageUrl
      }
      id
    }
}
`;
